import type { PEPnlBlock } from '../../types/peProfit';

export type BankKennzahlenBlock = {
  beVorSteuern: number;
  beNachSteuern: number;
  cashflow: number;
};

export type BankKennzahlenPayload = {
  ist: BankKennzahlenBlock;
  prognose: BankKennzahlenBlock;
};

const num = (value: unknown): number => Number(value) || 0;

/**
 * Bank-/BWA-Näherung aus PE-P&L-Block (Jahres- oder Monatswerte):
 * AfA als Kosten, dann Cashflow = BE nach Steuern + AfA.
 */
export const calcBankKennzahlenFromPnl = (block: PEPnlBlock): BankKennzahlenBlock => {
  const personalkosten =
    num(block.personalkostenProduktiv) + num(block.personalkostenUnproduktiv);
  const kostenOhneAfA =
    num(block.wareneinsatz) +
    personalkosten +
    num(block.betriebskosten) +
    num(block.geraetekosten) +
    num(block.investitionen);
  const afa = num(block.sonstigeEinnahmen);
  const est = num(block.einkommensteuer);
  const beVorSteuern = num(block.umsatzNetto) - kostenOhneAfA - afa;
  const beNachSteuern = beVorSteuern - est;
  const cashflow = beNachSteuern + afa;

  return {
    beVorSteuern,
    beNachSteuern,
    cashflow,
  };
};

export const buildBankKennzahlenPayload = (
  ist: PEPnlBlock,
  prognose: PEPnlBlock
): BankKennzahlenPayload => ({
  ist: calcBankKennzahlenFromPnl(ist),
  prognose: calcBankKennzahlenFromPnl(prognose),
});
